import type { StateCreator } from "zustand";
import type { IState } from "~/lib/stateManagement/persistedState/persistedStore";

export interface IWishlistState {
	wishlistIds: string[];
	wishlistRemoved: string[];
	setWishlistIds: (ids: string[]) => void;
	wishlistAddId: (id: string) => void;
	wishlistRemoveId: (id: string) => void;
	wishlistRestoreLastRemoved: () => void;
	wishlistClearIds: () => void;
	wishlistClearRemoved: () => void;
	wishlistClearAll: () => void;
	wishlistToggleId: (id: string) => void;
}

export const createWishlistSlice: StateCreator<IState, [], [], IWishlistState> = (set, _get) => ({
	wishlistIds: [],
	wishlistRemoved: [],
	setWishlistIds: (ids: string[]) =>
		set(() => {
			const toBeRemoved = ids.filter((id) => !_get().wishlistIds.includes(id));
			const toBeAdded = ids.filter((id) => !_get().wishlistIds.includes(id));
			return {
				wishlistIds: [..._get().wishlistIds, ...toBeAdded],
				wishlistRemoved: _get().wishlistRemoved.filter((id) => !toBeRemoved.includes(id)),
			};
		}),
	wishlistAddId: (id: string) =>
		set((state) => {
			return {
				wishlistIds: state.wishlistIds.includes(id)
					? state.wishlistIds
					: [id, ...state.wishlistIds],
				wishlistRemoved: state.wishlistRemoved.includes(id)
					? state.wishlistRemoved.filter((rId) => rId !== id)
					: state.wishlistRemoved,
			};
		}),
	wishlistRemoveId: (id: string) =>
		set((state) => {
			return {
				wishlistIds: state.wishlistIds.filter((wId) => wId !== id),
				wishlistRemoved: state.wishlistRemoved.includes(id)
					? state.wishlistRemoved
					: [id, ...state.wishlistRemoved],
			};
		}),
	wishlistRestoreLastRemoved: () =>
		set((state) => {
			const lastRemoved = state.wishlistRemoved[0];
			if (!lastRemoved) return {};
			state.wishlistAddId(lastRemoved);
			return {};
		}),
	wishlistClearIds: () =>
		set(() => ({
			wishlistIds: [],
		})),
	wishlistClearRemoved: () =>
		set(() => ({
			wishlistRemoved: [],
		})),
	wishlistClearAll: () =>
		set((state) => {
			state.wishlistClearIds();
			state.wishlistClearRemoved();
			return {};
		}),
	wishlistToggleId: (id: string) =>
		set((state) => {
			return {
				wishlistIds: state.wishlistIds.includes(id)
					? state.wishlistIds.filter((wId) => wId !== id)
					: [id, ...state.wishlistIds],
				wishlistRemoved: state.wishlistRemoved.includes(id)
					? state.wishlistRemoved.filter((rId) => rId !== id)
					: state.wishlistRemoved,
			};
		}),
});
